import { isProd } from '../config/env';
import { analytics } from './analytics';
import { SegmentFunctionTypeEnum, SegmentIdentifyData, SegmentPageData, SegmentTrackData } from './types';

/**
 * Flag to determine if analytics should be sent
 */
const SHOULD_SEND_ANALYTICS = import.meta.env.VITE_SEGMENT_ENABLED === 'true';

/**
 * Helper functions to call Segment APIs
 */
export function callSegmentIdentify(data: SegmentIdentifyData): void {
  callSegmentFunction(SegmentFunctionTypeEnum.IDENTIFY, data);
}

export function callSegmentPage(data: SegmentPageData): void {
  callSegmentFunction(SegmentFunctionTypeEnum.PAGE, data);
}

export function callSegmentTrack(data: SegmentTrackData): void {
  callSegmentFunction(SegmentFunctionTypeEnum.TRACK, data);
}

function callSegmentFunction(
  functionName: SegmentFunctionTypeEnum,
  data: SegmentIdentifyData | SegmentPageData | SegmentTrackData
): void {
  try {
    if (SHOULD_SEND_ANALYTICS) {
      switch (functionName) {
        case SegmentFunctionTypeEnum.IDENTIFY: {
          const identifyData = data as SegmentIdentifyData;
          analytics.identify(identifyData.userId, identifyData.traits);
          break;
        }
        case SegmentFunctionTypeEnum.TRACK: {
          const trackData = data as SegmentTrackData;
          analytics.track(trackData.event, trackData.properties);
          break;
        }
        case SegmentFunctionTypeEnum.PAGE: {
          // TODO: Commented to pause the analytics for pages.
          // Reason: We temporarily paused `analytics.page` because it triggers multiple events,
          // resulting in excessive log entries. This will be re-enabled once we optimize the
          // logging behavior and ensure page tracking doesn't overwhelm the system.
          // const pageData = data as SegmentPageData;
          // analytics.page(pageData.name, pageData.category, pageData.properties);
          break;
        }
      }
    } else if (!isProd()) {
      console.log(`Segment ${functionName}`, data);
    }
  } catch (error) {
    console.log(`Segment ${functionName}`, error, data);
  }
}
